import { z } from 'zod';

export const CandidateIndustrySchema = z.object({
  industryValue: z.string(),
  yearsOfExperience: z.string(),
});

export type CandidateIndustry = z.infer<typeof CandidateIndustrySchema>;
